export var BodyActivity;
(function (BodyActivity) {
    BodyActivity["ACTIVITY_SITTING"] = "ACTIVITY_SITTING";
    BodyActivity["ACTIVITY_STANDING"] = "ACTIVITY_STANDING";
    BodyActivity["ACTIVITY_RUNNING"] = "ACTIVITY_RUNNING";
})(BodyActivity || (BodyActivity = {}));
//# sourceMappingURL=body-activity.enum.js.map